export const NAV_INFO = [
  {
    id: 'A',
    hIcon: require('@/imgs/index/house/A_h.png'),
    nIcon: require('@/imgs/index/house/A_n.png'),
    title: require('@/imgs/index/house/A_title.png'),
    content: require('@/imgs/index/house/A_content.png'),
    contentW: '5rem',
    tag: require('@/imgs/index/house/A_tag.png'),
    tagW: '9.8rem',
    tLeft: '-48%',
    tTop: '-5.5%',
    pos: require('@/imgs/index/house/A-color.png'),
    posW: '1.38rem',
    pLeft: '11%',
    pTop: '45%',
    info: require('@/imgs/index/house/A_info.png'),
  },
  {
    id: 'B',
    hIcon: require('@/imgs/index/house/B_h.png'),
    nIcon: require('@/imgs/index/house/B_n.png'),
    title: require('@/imgs/index/house/B_title.png'),
    content: require('@/imgs/index/house/B_content.png'),
    contentW: '5rem',
    tag: require('@/imgs/index/house/B_tag.png'),
    tagW: '9rem',
    tLeft: '-36%',
    tTop: '-11%',
    pos: require('@/imgs/index/house/B-color.png'),
    posW: '2.65rem',
    pLeft: '25.5%',
    pTop: '30.5%',
    info: require('@/imgs/index/house/B_info.png'),
  },
  {
    id: 'C',
    hIcon: require('@/imgs/index/house/C_h.png'),
    nIcon: require('@/imgs/index/house/C_n.png'),
    title: require('@/imgs/index/house/C_title.png'),
    content: require('@/imgs/index/house/C_content.png'),
    contentW: '6.42rem',
    tag: require('@/imgs/index/house/C_tag.png'),
    tagW: '9rem',
    tLeft: '-22%',
    tTop: '-7%',
    pos: require('@/imgs/index/house/C-color.png'),
    posW: '4.33rem',
    pLeft: '6%',
    pTop: '27.5%',
    info: require('@/imgs/index/house/C_info.png'),
  },
  {
    id: 'D',
    hIcon: require('@/imgs/index/house/D_h.png'),
    nIcon: require('@/imgs/index/house/D_n.png'),
    title: require('@/imgs/index/house/D_title.png'),
    content: require('@/imgs/index/house/D_content.png'),
    contentW: '6.92rem',
    tag: require('@/imgs/index/house/D_tag.png'),
    tagW: '9rem',
    tTop: '-5%',
    tLeft: '-18%',
    pos: require('@/imgs/index/house/D-color.png'),
    posW: '1.38rem',
    pLeft: '31.5%',
    pTop: '31.5%',
    info: require('@/imgs/index/house/D_info.png'),
  },
  {
    id: 'E',
    hIcon: require('@/imgs/index/house/E_h.png'),
    nIcon: require('@/imgs/index/house/E_n.png'),
    title: require('@/imgs/index/house/E_title.png'),
    content: require('@/imgs/index/house/E_content.png'),
    contentW: '7.25rem',
    tag: require('@/imgs/index/house/E_tag.png'),
    tagW: '8.45rem',
    tTop: '-8%',
    tLeft: '-10.5%',
    pos: require('@/imgs/index/house/E-color.png'),
    posW: '1.86rem',
    pLeft: '3%',
    pTop: '49.5%',
    info: require('@/imgs/index/house/E_info.png'),
  },
];

export const TEST_NAV_INFO = [
  // {
  //   name: 'book',
  //   width: 39.2,
  //   height: 25.6,
  //   nIcon: require('@/imgs/nav/book_n.png'),
  //   hIcon: require('@/imgs/nav/book_h.png'),
  // },
];
